import styled from 'styled-components';

export const Wrapper = styled.div(({ theme: { transition } }) => ({
  '& svg': {
    display: 'flex',
    transition: transition.standard('color'),
  },
}));
